import { apiPost, apiPut, apiDelete } from './apiClient';
import { ResponseDTO, MultipleAppTag, MultipleDeviceTag, MultiplePolicyTag, AppTag, DeviceTagAssignment, PolicyTag } from '@/types/api';

// --- App Tags ---

export async function assignAppTags(data: MultipleAppTag): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>('/api/v1/tag/app-tag', data);
  return res.message || 'Tags assigned';
}

export async function updateAppTags(data: MultipleAppTag): Promise<string> {
  const res = await apiPut<ResponseDTO<null>>('/api/v1/tag/app-tag', data);
  return res.message || 'Tags updated';
}

export async function unassignAppTags(data: AppTag): Promise<string> {
  const res = await apiDelete<ResponseDTO<null>>('/api/v1/tag/app-tag', data);
  return res.message || 'Tags removed';
}

// --- Device Tags ---

export async function assignDeviceTags(data: MultipleDeviceTag): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>('/api/v1/tag/device-tag', data);
  return res.message || 'Tags assigned';
}

export async function updateDeviceTags(data: MultipleDeviceTag): Promise<string> {
  const res = await apiPut<ResponseDTO<null>>('/api/v1/tag/device-tag', data);
  return res.message || 'Tags updated';
}

export async function unassignDeviceTags(data: DeviceTagAssignment): Promise<string> {
  const res = await apiDelete<ResponseDTO<null>>('/api/v1/tag/device-tag', data);
  return res.message || 'Tags removed';
}

// --- Policy Tags ---

export async function assignPolicyTags(data: MultiplePolicyTag): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>('/api/v1/tag/policy-tag', data);
  return res.message || 'Tags assigned';
}

export async function updatePolicyTags(data: MultiplePolicyTag): Promise<string> {
  const res = await apiPut<ResponseDTO<null>>('/api/v1/tag/policy-tag', data);
  return res.message || 'Tags updated';
}

export async function unassignPolicyTags(data: PolicyTag): Promise<string> {
  const res = await apiDelete<ResponseDTO<null>>('/api/v1/tag/policy-tag', data);
  return res.message || 'Tags removed';
}
